// extracted by mini-css-extract-plugin
module.exports = {"cardDetailed":"styles_cardDetailed__0a31g"};